module.exports = __webpack_public_path__ + "static/media/1020001BE.1f3e0df7.jpg";